<template>
  <div class="rounded-[14px] overflow-hidden">
    <component
      :is="isPreview() ? 'iframe' : `db-youtube`"
      :class="formatClass"
      loading="lazy"
      :src="`https://www.youtube-nocookie.com/embed/${id}?&cc_lang_pref=${locale}&hl=${locale}`"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      :title="title"
      :headline="isPreview() ? '' : consentLayer?.headline"
      :description="isPreview() ? '' : consentLayer?.description"
    />
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  id: string
  title: string
  consentLayer: ConsentLayer
  format?: ImageFormat | null
}>()

const { locale } = useI18n()

const formatClass = computed(() => {
  if (!props.format) return 'dbc-c-image--16-9'

  if (props.format === 'as-is') return null

  return `dbc-c-image--${props.format.replace('f', '')}`
})
</script>
